import { atom } from 'nanostores'

export const $openModalProcess = atom(false)

export const $titleProcessing = atom<string>('')

export const onOpenModalProcessing = (title?: string) => {
  $openModalProcess.set(true)
  $titleProcessing.set(title || '')
}

export const onCloseModalProcessing = () => {
  $openModalProcess.set(false)
  $titleProcessing.set('')
}
